export default __webpack_public_path__ + "static/5-9fc357a9859a14adf84937677993c100.jpg";